//hooks/useSavedListings.jsx

import { useState, useEffect } from 'react';
import { getFirestore, doc, getDoc } from 'firebase/firestore';
import { useAuth } from './useAuth';

const firestore = getFirestore();

const useSavedListings = () => {
  const { currentUser } = useAuth();
  const [savedListings, setSavedListings] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentUser) {
      setSavedListings([]);
      setLoading(false);
      return;
    }

    const fetchSavedListings = async () => {
      try {
        setLoading(true);
        const userDoc = await getDoc(doc(firestore, 'users', currentUser.uid));
        if (userDoc.exists()) {
          const favorites = userDoc.data().favorites || [];
          setSavedListings(favorites);
        }
      } catch (error) {
        console.error('Error fetching saved listings:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSavedListings();
  }, [currentUser]);

  return { savedListings, loading };
};

export default useSavedListings;
